export default {
    confirm_delete_title: 'លុបចោលកំណត់ត្រា?',
    confirm_delete_text: 'អ្នកប្រាកដថាចង់លុបកំណត់ត្រាមែនទេ?',
    confirm: 'បញ្ជាក់',
    power_confirm: 'វាអាចប៉ះពាល់ដល់ដំណើរការសកម្មនៅលើម៉ាស៊ីនមេ!',
    change_server_info:
        '​អ្នក​ប្រាកដ​ចថាចង់​ផ្លាស់ប្ដូរ​ព័ត៌មាន​របស់​ម៉ាស៊ីន​មេមែនទេ?',
};
